<template>
  <!--回复或者评论的编辑器-->
  <div class="commentWrap">
    <div class="commentBox">
      <div id="wangeditor" class="wangeditorBox">

        <mavon-editor ref="mavonEditor" v-model="text" :language="$i18n.locale" :toolbars="config.toolbars" :ishljs="config.ishljs" :subfield="config.subfield"
                     :previewBackground="previewStyle"
                      :toolbarsBackground="toolBarstyle"
                      :editorBackground="editorStyle"
                      @imgAdd="$imgAdd"
                      @imgDel="$imgDel"
                      :placeholder="'分享你的独特见解，点燃智慧的火花！拒绝无关灌水，一起为学习加油，共建充满活力的学习社区！'"  />

      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mavonEditor} from 'mavon-editor'
  import 'mavon-editor/dist/css/index.css'

  export default {
    data() {
      return {
        config: {
          ishljs: true,
          subfield: true,
          defaultOpen: "edit",
          toolbars: {
            header: true, // 标题
            bold: true, // 粗体
            italic: true, // 斜体
            underline: true, // 下划线
            strikethrough: true, // 中划线

            superscript: true, // 上角标
            subscript: true, // 下角标
            quote: true, // 引用
            ol: true, // 有序列表
            ul: true, // 无序列表
            link: true, // 链接
            imagelink: true, // 图片链接
            code: true, // code

            undo: true, // 上一步
            redo: true, // 下一步
            trash: true, // 清空

            preview: true, // 预览
            fullscreen: true,
          }
        },
        previewStyle: "",
        toolBarstyle: "",
        editorStyle: "",
        text:""
      }
    },
    created() {
      this.setTheme();
    },
    mounted() {},
    methods: {
      setTheme() {
        if(this.themeVal == 'black'){
        this.toolBarstyle = "#46474f";
        this.previewStyle = "#46474f";
        this.editorStyle = "#46474f"
      }else{
         this.toolBarstyle = "#ffffff";
         this.previewStyle = "#ffffff";
         this.editorStyle = "#ffffff"
      }
      },

      setText(text){
        this.text =  text;
      },
      getText(){
        return this.text;
      },

      $imgAdd(pos, $file){
        // 图片大小不能超过2mb
        if ($file.size > 2 * 1024 * 1024) {
          this.$message.error('上传的文件大小不能超过2M');
          return Promise.reject('上传的文件大小不能超过2M');
        }
        // 第一步.将图片上传到服务器.
        var formdata = new FormData();
        formdata.append('bbsImgFile', $file);
        axios({
          url: '/bbs/uploadBbsImg',
          method: 'post',
          data: formdata,
          headers: {'Content-Type': 'multipart/form-data' ,},
        }).then((res) => {
          let url = res.data.data;
          this.$refs.mavonEditor.$img2Url(pos, url);
        })
      }
      ,$imgDel(){
        console.log("img delete")
      }
    },
    components: {
      mavonEditor
    },
  }
</script>





// WEBPACK FOOTER //
// src/components/markdown/bbs.vue